import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { OfferService } from "../../../../@core/api/offer.service";
import { Offer } from "../../../../@core/data/offer";
import { Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "ngx-offer-row",
  templateUrl: "./offer-row.component.html",
  styleUrls: ["./offer-row.component.scss"],
})
export class OfferRowComponent implements OnInit {
  @Input() offer: Offer;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private offerService: OfferService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "edit":
        this.router.navigate(["home", "offer", this.offer.id]);
        break;
      case "copy":
        this.copyOffer();
        break;
      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.offer.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteOffer();
            }
          });
        break;
    }
  }

  async copyOffer() {
    let offer = this.offer;
    offer.name = offer.name + " (Copia)";
    let res = <any>await this.offerService.createOffer(offer);
    this.updateList.emit();
  }


  async DeleteOffer() {
    await this.offerService.deleteOffer(this.offer.id);
    this.updateList.emit();
  }
}
